<template>
    <DefaultTemplate :model="model">
        <div class="container">
            <div class="mt-12 mb-8">
                <Breadcrumbs :breadcrumbs="model.breadcrumbs" className="text-grey-400"/>
            </div>

            <div class="block lg:flex">
                <div class="w-full lg:w-3/4 pr-0 lg:pr-4">
                    <div v-epi-edit="'ForsideKategori'"
                         v-if="model.fagfellevurdert || model.redaksjonsomtale || model.forsideKategori || epiContext.inEditMode"
                         class="flex flex-wrap space-x-2 justify-end lg:hidden mb-6 text-right">
                        <span v-if="(model.forsideKategori || epiContext.inEditMode) && isForebyggingStandardPage()"
                              class="text-xs font-bold tracking-wider p-1 text-white rounded-sm"
                              :class="[categoryColor ? `bg-${categoryColor}-600` : 'bg-green-600']">
                            {{ model.forsideKategori }}
                        </span>
                        <span v-if="model.redaksjonsomtale"
                              class="text-xs font-bold tracking-wider bg-gray-500 p-1 text-white rounded-sm">
                            Tilrettelagt av redaksjonen
                        </span>
                        <span v-if="model.fagfellevurdert"
                              class="text-xs font-bold tracking-wider p-1 text-white rounded-sm"
                              :class="[categoryColor ? `bg-${categoryColor}-600` : 'bg-green-600']">
                            Fagfellevurdert artikkel
                        </span>
                    </div>
                    <div v-epi-edit="'Images'"
                         v-if="(model.images && model.images.length > 0) || epiContext.inEditMode">
                        <ImageSlider :images="model.images" :params="imageParams"/>
                    </div>

                    <article v-if="model.imageText || epiContext.inEditMode"
                             class="p-4 md:px-10 md:py-4 lg:px-6 lg:py-4 bg-white">
                        <div v-epi-edit="'imageText'"
                             v-if="(epiContext.inEditMode || model.imageText) && isForebyggingStandardPage()"
                             class="italic text-base text-gray-500">
                            {{ model.imageText }}
                        </div>
                    </article>

                    <article :class="[categoryColor ? `border-${categoryColor}-500` : 'border-white']"
                             class="p-4 md:px-10 md:py-4 lg:px-20 lg:py-10 mb-4 bg-white border-t-10">

                        <h1 v-if="model.heading || epiContext.inEditMode"
                            v-epi-edit="'Heading'"
                            class="mb-2">
                            {{ model.heading }}
                        </h1>
                        <h1 v-else
                            v-epi-edit="'Name'"
                            class="mb-2">
                            {{ model.name }}
                        </h1>
                        <div v-if="model.subTitle || epiContext.inEditMode"
                             v-epi-edit="'SubTitle'"
                             class="text-base text-gray-500">
                            {{ model.subTitle }}
                        </div>

                        <!--<p v-if="!this.model.hideByline" class="mb-0 text-grey-400">
                            {{ new Date(this.model.startPublish).toLocaleDateString('nb-NO', dateOptions) }} &mdash; <span v-epi-edit="'MetaAuthor'" v-html="author"></span>
                        </p>-->

                        <hr class="my-4 lg:my-4"/>

                        <div v-if="model.intro" v-epi-edit="'Intro'" class="main-body my-4 article pt-4"
                             v-html="this.model.intro"/>
                        <div v-if="model.mainBody" v-epi-edit="'MainBody'" id="main-body"
                             class="main-body my-4 article pt-4" v-html="this.model.mainBody"/>
                        <ContentArea v-epi-edit="'MainContent'" :model="model.mainContent"/>
                        <div v-epi-edit="'SecondaryBody'" id="seconday-body" class="main-body my-4 article"
                             v-html="this.model.secondaryBody"/>
                    </article>
                </div>
                <aside class="w-full lg:w-1/4 pr-0 lg:pl-4 mb-4">
                    <div
                        v-if="model.fagfellevurdert || model.redaksjonsomtale || model.forsideKategori || epiContext.inEditMode && isForebyggingStandardPage()"
                        class="hidden lg:flex lg:flex-wrap lg:justify-end lg:space-x-2 mb-4 text-right">
                        <span v-epi-edit="'ForsideKategori'" v-if="model.forsideKategori || epiContext.inEditMode"
                              class="text-xs font-bold tracking-wider p-1 text-white rounded-sm mb-2"
                              :class="[categoryColor ? `bg-${categoryColor}-600` : 'bg-green-600']">
                            {{ model.forsideKategori }}
                        </span>
                        <span v-if="model.redaksjonsomtale"
                              class="text-xs font-bold tracking-wider bg-gray-500 p-1 text-white rounded-sm mb-2">
                            Tilrettelagt av redaksjonen
                        </span>
                        <span v-if="model.fagfellevurdert"
                              class="text-xs font-bold tracking-wider p-1 text-white rounded-sm mb-2"
                              :class="[categoryColor ? `bg-${categoryColor}-600` : 'bg-green-600']">
                            Fagfellevurdert artikkel
                        </span>
                    </div>

                    <article-box v-if="epiContext.inEditMode" :header='`Ulike instillinger for denne siden`'>
                        <div>
                            <EpiProperty v-if="isForebyggingStandardPage()" propertyName="Redaksjonsomtale"
                                         displayText="Tilrettelagt av redaksjonen"/>
                            <EpiProperty propertyName="Fagfellevurdert" displayText="Fagfellevurdert"/>
                            <EpiProperty propertyName="VisDatoOgForfatter" displayText="Vis publisert/forfatterinfo"/>
                            <EpiProperty v-show="!this.model.imageTopRight" propertyName="ImageTopRight"
                                         displayText="Forfatterbilde"/>
                            <EpiProperty propertyName="HideByline" displayText="Skjul byline"/>
                            <EpiProperty propertyName="MetaAuthorHeading" displayText="Forfatteroverskrift"/>
                            <EpiProperty propertyName="ImageCrop" displayText="Bildeutsnitt"/>
                            <EpiProperty v-if="isForebyggingStandardPage()" propertyName="HandlingMalgr"
                                         displayText="Målgruppe for handlingstiltak"/>
                            <EpiProperty v-if="isForebyggingStandardPage()" propertyName="SideTema"
                                         displayText="Sidetema"/>
                        </div>
                    </article-box>

                    <!-- Metadata - dato -->
                    <article-box v-if="model.visDatoOgForfatter || epiContext.inEditMode"
                                 :header='`Publisert`'
                                 :headerRight="`Revidert`"
                                 :text="new Date(this.model.startPublish).toLocaleDateString('nb-NO', dateOptions)"
                                 :textRight="new Date(this.model.changed).toLocaleDateString('nb-NO', dateOptions)"
                                 :colorTheme="categoryColor">
                    </article-box>
                    <!-- // Metadata - dato -->
                    <!-- Forfatter -->
                    <div v-show="model.forfatterInfo !== '' || author !== '' || authorImage !== null || authors !== null">
                        <div v-if="model.authors && model.authors.length">
                            <article-box v-if="model.authors && model.authors.length" :header="model.authors.length === 1 ? 'Forfatter' : 'Forfattere'">
                                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 pt-2 gap-4"
                                     v-epi-edit="'Authors'">
                                    <div v-for="author in model.authors"
                                         :key="author.id">
                                        <div class="w-full">
                                            <img v-if="author.image"
                                                 :src="author.image + '?width=300&height=400&crop=auto'"
                                                 :alt="author.fullName"
                                                 class="block w-full h-auto" />
                                            <p class="pt-2">
                                                <span class="font-bold leading-tight">{{ author.fullName }}</span><br>
                                                <span class="ForfatterInfo">{{ author.credentials }}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </article-box>
                        </div>
                        <div v-else>
                            <article-box v-if="model.visDatoOgForfatter || epiContext.inEditMode" :header="(model.kategori !== undefined && model.kategori.name) === 'Bokomtaler' ? 'Bokomtaler':
                                 model.metaAuthorHeading === '' ? 'Forfatter' : model.metaAuthorHeading"
                                         :colorTheme="categoryColor">
                                <img v-epi-edit="'ImageTopRight'" v-if="authorImage" :src="authorImage"
                                     :alt="this.model.metaAuthor" class="mb-4 mt-1" />
                                <p v-if="author || epiContext.inEditMode" v-epi-edit="'MetaAuthor'" class="font-bold"
                                   v-html="author"></p>
                                <div v-if="model.forfatterInfo || epiContext.inEditMode" v-epi-edit="'ForfatterInfo'"
                                     v-html="model.forfatterInfo" />
                            </article-box>
                        </div>
                    </div>
                    <!-- // Forfatter -->
                    <!-- ORCID -->
                    <article-box v-if="model.orcids || epiContext.inEditMode" :header='`ORCID`'>
                        <ul>
                            <li v-for="orcid in model.orcids" :key="orcid.code">
                                <a :href="orcid.url"
                                   :title="orcid.name"
                                   target="_blank">
                                    {{ orcid.name }}
                                </a>
                            </li>
                        </ul>
                        <!--<a v-epi-edit="'ORCID'" :href="model.orcidUrl" target="_blank">{{model.orcid}}</a>-->
                    </article-box>
                    <!-- // ORCID -->
                    <!-- Utgiver og utgivelsesår -->
                    <article-box
                        v-if="model.utgiver || model.utgivelsesAar || epiContext.inEditMode && isForebyggingStandardPage()"
                        :header='`Utgiver / utgivelsesår`' :colorTheme="categoryColor">
                        <p><span v-epi-edit="'Utgiver'">{{ model.utgiver }}</span> / <span v-epi-edit="'UtgivelsesAar'">{{
                                model.utgivelsesAar
                            }}</span></p>
                    </article-box>
                    <!-- // Utgiver og utgivelsesår -->
                    <!-- Main list items -->
                    <article-box v-epi-edit="'MainListItems'" v-if="model.mainListItems" :colorTheme="categoryColor">
                        <ul>
                            <li v-for="item in model.mainListItems"
                                :key="item.id">
                                <a :href="item.url"
                                   :title="item.name"
                                   class="text-black hover:text-green-500 underline truncate mr-2">
                                    {{ item.name }}
                                </a>
                            </li>
                        </ul>
                    </article-box>
                    <!-- // Main list items -->
                    <!-- Referanse -->
                    <article-box v-if="artikkelReferanse || epiContext.inEditMode" :header='articleRef'
                                 :headerPropname="'artikkelReferanseTitle'" :html="artikkelReferanse"
                                 :htmlPropname="'artikkelReferanse'" :colorTheme="categoryColor">
                    </article-box>
                    <!-- // Referanse -->
                    <!-- DOI -->
                    <article-box v-if="model.doi || epiContext.inEditMode && isForebyggingStandardPage()"
                                 :header='`DOI`' :colorTheme="categoryColor">
                        <div v-epi-edit="'DOI'">
                            <a :href="model.doi" target="_blank">{{ model.doi }}</a>
                        </div>
                    </article-box><!-- // DOI -->
                    <!-- Documents -->
                    <article-box v-if="documents.length > 0 || epiContext.inEditMode" :header='documentsTitle'
                                 :colorTheme="categoryColor" :headerPropname="'RessurserDokumenterTittel'">
                        <dl v-epi-edit="'RessurserDokumenter'">
                            <dd v-for="item in documents" :key="item.title" class="pt-2">
                                <div class="text-grey-400 hover:text-green-500">
                                    <a :href="item.url" :target="item.target" :title="item.text">
                                        <div class="flex flex-row">
                                            <div class="flex-1 text-black hover:text-green-500 underline truncate mr-2">
                                                {{ item.text }}
                                            </div>
                                            <font-awesome-icon style="margin-top: 6px;" icon="file-alt"/>
                                        </div>
                                    </a>
                                </div>
                            </dd>
                        </dl>
                    </article-box>
                    <!-- // Documents -->
                    <!-- Internal pages -->
                    <article-box v-if="internalPages.length > 0 || epiContext.inEditMode && isForebyggingStandardPage()"
                                 :header='internalPagesTitle' :colorTheme="categoryColor"
                                 :headerPropname="'RelatedPagesTitle'">
                        <dl v-epi-edit="'relatedPages'">
                            <dd v-for="item in internalPages" :key="item.title" class="pt-2">
                                <div class="text-grey-400 hover:text-green-500">
                                    <a :href="item.url" :target="item.target" :title="item.text">
                                        <div class="flex flex-row">
                                            <div class="flex-1 text-black hover:text-green-500 underline truncate mr-2">
                                                {{ item.text }}
                                            </div>
                                            <font-awesome-icon style="margin-top: 6px;" icon="link"/>
                                        </div>
                                    </a>
                                </div>
                            </dd>
                        </dl>
                    </article-box>
                    <!-- // Internal pages -->
                    <!-- External pages -->
                    <article-box v-if="(externalPages.length > 0) || epiContext.inEditMode" :header='externalPagesTitle'
                                 :colorTheme="categoryColor" :headerPropname="'externalPagesTitle'">
                        <dl v-epi-edit="'EksterneSider'">
                            <dd v-for="item in externalPages" :key="item.title" class="pt-2">
                                <div class="text-grey-400 hover:text-green-500">
                                    <a :href="item.url" :target="item.target" :title="item.text">
                                        <div class="flex flex-row">
                                            <div class="flex-1 text-black hover:text-green-500 underline truncate mr-2">
                                                {{ item.text }}
                                            </div>
                                            <font-awesome-icon style="margin-top: 6px;" icon="external-link-alt"/>
                                        </div>
                                    </a>
                                </div>
                            </dd>
                        </dl>
                    </article-box>
                    <!-- // External pages -->
                    <!-- Nøkkelord -->
                    <article-box v-if="model.nokkelord || epiContext.inEditMode && isForebyggingStandardPage()"
                                 :header="`Nøkkelord`" :html="model.nokkelord" :htmlPropname="'nokkelord'"
                                 :colorTheme="categoryColor"/>
                    <!-- // Nøkkelord  -->
                    <!-- PDF -->
                    <article-box v-if="model.pdfUtgave || epiContext.inEditMode" :header='`PDF-utgave`'
                                 :colorTheme="categoryColor">
                        <div v-epi-edit="'pdfUtgave'" class="">
                            <a :href="model.pdfUtgave" title="Last ned PDF" target="_blank"
                               class="group flex underline hover:text-green-500 leading-loose" content="Last ned PDF"
                               v-tippy="{ placement : 'bottom' }">
                                <font-awesome-icon icon="file-pdf"
                                                   class="text-3xl pr-2 text-red-600  group-hover:text-green-500"/>
                                <p>Last ned PDF</p>
                            </a>
                        </div>
                    </article-box>
                    <!-- // PDF -->

                    <div class="flex justify-end mt-6 print:hidden">
                        <Sharing/>
                    </div>
                </aside>
            </div>
        </div>
    </DefaultTemplate>
</template>

<script>
import Breadcrumbs from '@/Scripts/components/organisms/Breadcrumbs/breadcrumbs.vue';
import ContentArea from '@/Scripts/components/ContentArea.vue';
import EpiProperty from '@/Scripts/components/EpiProperty.vue';
import Sharing from '@/Scripts/components/atoms/Sharing/Sharing.vue';
import ImageSlider from '@/Scripts/components/atoms/ImageSlider/ImageSlider.vue';
import ArticleBox from '@/Scripts/components/atoms/ArticleBox/ArticleBox.vue';
import {mapGetters} from 'vuex';

export default {
    props: ['model'],
    components: {
        Breadcrumbs,
        ContentArea,
        EpiProperty,
        Sharing,
        ArticleBox,
        ImageSlider,
    },

    computed: {
        ...mapGetters({
            epiContext: 'getEpiContext'
        })
    },
    data() {
        const {kategori} = this.model;
        return {
            categoryColor: (kategori && kategori.color ? kategori.color : null),
            dateOptions: {year: 'numeric', month: '2-digit', day: '2-digit'},
            authorImage: this.model.imageTopRight ? this.model.imageTopRight + '?scale=both&width=320&mode=pad&anchor=middleleft' : null,
            author: this.model.metaAuthor ? this.model.metaAuthor : '',

            artikkelReferanse: this.model.artikkelReferanse ? this.model.artikkelReferanse : false,
            articleRef: this.model.artikkelReferanseTitle ? this.model.artikkelReferanseTitle : 'Artikkelreferanse',

            internalPages: this.model.internalPages ? this.model.internalPages : [],
            internalPagesTitle: this.model.internalPagesTitle ? this.model.internalPagesTitle : 'Interne lenker',

            externalPages: this.model.externalPages ? this.model.externalPages : [],
            externalPagesTitle: this.model.externalPagesTitle ? this.model.externalPagesTitle : 'Eksterne lenker',

            documents: this.model.documents ? this.model.documents : [],
            documentsTitle: this.model.documentsTitle ? this.model.documentsTitle : 'Dokumenter',

            imageParams: this.model.imageResizerParams ? 'scale=both&width=1112&maxheight=500&' + this.model.imageResizerParams : 'scale=both&width=1112&maxheight=500&',

            authors: this.model.authors ? this.model.authors : []
        };
    },
    methods: {
        mapIcon(type) {
            switch (type) {
                case 'pdf':
                    return 'file-pdf';
                default:
                    return 'file-alt';
            }
        },
        isForebyggingStandardPage() {
            return this.model.contentType.indexOf('ForebyggingStandardPage') > -1;
        }
    }
};
</script>
